export const formMessages = {
    required: () => 'Required',
    email: () => 'Must be a valid e-mail',
    emailExists: () => 'E-mail already exists',
    validateEmail: () => 'Must be a valid e-mail'
};
